import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { TLDS } from './meta';

/**
 * Identifies a valid portion of a domain, according to the rules defined here:
 * https://developer.mozilla.org/en-US/docs/Learn/Common_questions/What_is_a_domain_name
 *
 * Labels must contain "only the letters A through Z, digits 0 through 9, and
 * the `-` character". For our use, we are ignoring the additional length
 * limits and the restriction against using the `-` character in the first or
 * last positions; we will instead lean on the DNS system and/or the browser
 * to prevent pages with invalid domains from loading.
 */
var label = '[\\-a-z0-9]+';
/**
 * Identifies a valid TLD from our configured list of used TLDs.
 */

var tld = TLDS.join('|').replace('.', '\\.');
var hostnameRegex = "^(?:(".concat(label, ")\\.)?(").concat(label, ")\\.onepeloton\\.(").concat(tld, ")$");
/**
 * Parses a `hostname` into its parts:
 * TLD, Domain, Subdomain, and SubSubdomain.
 *
 * @param hostname A hostname string, such as from `window.location.hostname`.
 */

export var toHostnameComponents = function toHostnameComponents(hostname) {
  var match = hostname === null || hostname === void 0 ? void 0 : hostname.match(hostnameRegex);

  if (!match) {
    return undefined;
  }

  var _match = _slicedToArray(match, 4),
      subSubdomain = _match[1],
      subdomain = _match[2],
      tld = _match[3];

  return {
    subdomain: subdomain,
    subSubdomain: subSubdomain,
    tld: tld
  };
};